const NarcoticsQualitativeQuestions = [
  "All Narcotic And Controlled Substances Are Kept Under Double Lock Until Destruction",
  "Only Narcotic And Controlled Substances Are Stored In Narcotic & Controlled Med Bin",
  "Narcotic And Controlled Count Records Match Between Individual Count Sheets Vs. Shift Count Sheets",
  "Individual Count Sheets Vs. Shift Count Sheet",
  "Shift Count Sheets Are Not Pre-Signed",
  "No Corrections Or Changes Made To Previous Counts",
  "Shift Count Is Completed By 2 Nurses",
  "Any Wasted Narcotics Are Double Signed",
  "Monthly Audit Of Shift Count Sheets Is Completed To Identify Discrepancies",
  "Sign Nurse Reviewed/Audited On Bottom Of Sheet",
  "Expired And Discontinued Medications Have Been Removed From Medication Cart",
  "Used Narcotic Patches Are Removed And Placed On 'Patch Disposal Record Sheet', Sheet Is Placed In Double Locked Surplus Monitored Drug Storage And Double Signed Onto Drug Destruction And Disposal Sheet",
  "The Drug Destruction And Disposal Record Is Complete, Double Initialed And Kept With Meds Until Disposal (Use Binder)",
  "The Medication Room Has No Expired Medication",
  "Drug dentured with Detergent by Nurse and Doc Designate",
];

export default NarcoticsQualitativeQuestions;
